import builtinBrandPacksJson from "./brand-packs-data";

import type { BrandPack, Theme } from "@shared/types";

/**
 * 品牌包数据源（ARCHITECTURE_DESIGN.md §5.5）。
 *
 * 6 个内置包的完整定义存放在 shared/contracts/brand-packs.json，与后端 API
 * 共用同一份文件，避免两端漂移（前端经 brand-packs-data.ts 中转 import；
 * 后端按 DEBUGPAVILION_ROOT 相对路径读取同一文件）。
 */
const builtinBrandPacks: BrandPack[] = builtinBrandPacksJson;

/** 返回 6 个内置品牌包（tech-startup/enterprise/creative/minimal/vibrant/dark-pro）。 */
export function listBuiltinBrandPacks(): BrandPack[] {
  return builtinBrandPacks;
}

/**
 * 将品牌包 tokens 映射为 Theme（§5.5 → §5.4 视觉标准）。
 *
 * - 品牌包基于深色科技风基调设计，应用时默认将 darkMode 置为 true；
 *   用户仍可在主题面板中手动关闭。
 * - 未映射的 Theme 字段（如 textColor）保留原值；映射字段以品牌包为准。
 */
export function applyBrandPack(pack: BrandPack, theme: Theme = {}): Theme {
  return {
    ...theme,
    primaryColor: pack.tokens.primary,
    secondaryColor: pack.tokens.secondary,
    backgroundColor: pack.tokens.background,
    surfaceColor: pack.tokens.surface,
    fontHeading: pack.tokens.font_heading,
    fontBody: pack.tokens.font_body,
    borderRadius: pack.tokens.radius,
    spacingUnit: pack.tokens.spacing_unit,
    darkMode: true,
    brandPackId: pack.brand_id,
    motionPreset: pack.motion_preset,
  };
}

export interface SwatchColor {
  name: string;
  value: string;
}

/** 提取品牌包的色板（primary/secondary/background/surface），供选择器预览与测试。 */
export function brandPackSwatches(pack: BrandPack): SwatchColor[] {
  const { primary, secondary, background, surface } = pack.tokens;
  return [
    { name: "primary", value: primary },
    { name: "secondary", value: secondary },
    { name: "background", value: background },
    { name: "surface", value: surface },
  ];
}
